import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const SeoMenu = () => {
  function logoutUser() {
    localStorage.clear();
    window.location.replace("/login");
  }
  const location = useLocation();
  const userType = JSON.parse(localStorage.getItem("user"));
  const [isOpen, setIsOpen] = useState(false);

  const toggleSubMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuToggle = (menuName) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  const [isOpenDestination, setIsOpenDestination] = useState(false);

  const toggleSubMenuDestination = () => {
    setIsOpenDestination((prev) => !prev);
  };

  return (
    <>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <a href="#" className="brand-link text-center d-none d-md-block">
          <img
            src="../dist/img/logo.webp"
            style={{ width: "100px", margin: "0 auto !important" }}
            alt="Superbmytrip Logo"
            className="brand-image elevation-3"
          />
          <img
            src="../dist/img/favicon.webp"
            style={{ width: "30px", margin: "0 auto !important" }}
            alt="Superbmytrip Logo"
            className="brand-image elevation-3 img2"
          />
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link
                  to="dashboard"
                  className={
                    location.pathname === "/dashboard"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>
                    Dashboard
                    {/* <i className="right fas fa-angle-left" /> */}
                  </p>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="flight-bookings"
                  className={
                    location.pathname === "/flight-bookings" ||
                      location.pathname.startsWith("/booking-detail/")
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  {/* <i className="nav-icon fas-solid fa-plane"></i> */}
                  <i className="nav-icon fas fa-plane" />
                  <p>Flight Bookings</p>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="coupons"
                  className={
                    location.pathname === "/coupons"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="nav-icon fas fa-percent"></i>
                  <p>
                    Coupons
                    <span className="right badge badge-danger">New</span>
                  </p>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="holiday-bookings"
                  className={
                    location.pathname === "/holiday-bookings" ||
                      location.pathname.startsWith("/holiday-bookings/")
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  <i className="nav-icon fas fa-umbrella-beach" />
                  <p>Holiday Bookings</p>
                </Link>
              </li>

              {/* <li className="nav-item">
                                <Link
                                    to="configurations"
                                    className={
                                        location.pathname === "/configurations" ||
                                            location.pathname.startsWith("/edit-configuration/") ||
                                            location.pathname === "/add-configuration" ||
                                            location.pathname.startsWith("/add-configuration/")
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <i className="nav-icon fas fa-briefcase" />
                                    <p>
                                        Vendor
                                    </p>
                                </Link>
                            </li> */}

              <li className="nav-item">
                <Link onClick={toggleSubMenu} className="nav-link">
                  <i className="nav-icon fas fa-list"></i>
                  <p>
                    Manage Packages
                    <i
                      className={`right fas fa-angle-left ${isOpen ? "open" : ""
                        }`}
                    />
                  </p>
                </Link>

                <ul
                  className="nav nav-treeview"
                  style={{ display: isOpen ? "block" : "none" }} // Force display based on isOpen
                >
                  <li className="nav-item">
                    <Link
                      to="/package-list"
                      className={`nav-link ${location.pathname === "/package-list" ? "active" : ""
                        }`}
                    >
                      <i className="nav-icon fas fa-clipboard-list"></i>
                      <p>Packages List</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/category-list"
                      className={`nav-link ${location.pathname === "/category-list" ? "active" : ""
                        }`}
                    >
                      <i className="nav-icon fas fa-clipboard-list"></i>
                      <p>Category List</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/destination-list"
                      className={`nav-link ${location.pathname === "/destination-list"
                          ? "active"
                          : ""
                        }`}
                    >
                      <i className="nav-icon fas fa-umbrella-beach"></i>
                      <p>Destination List</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="feedbacks"
                      className={
                        location.pathname === "/feedbacks" ||
                          location.pathname.startsWith("/edit-feedback/") ||
                          location.pathname === "/add-feedback" ||
                          location.pathname.startsWith("/add-feedback/")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fas fa-star"></i>
                      <p>&nbsp;Feedback List</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link onClick={() => handleMenuToggle("offers")} className="nav-link">
                  <i className="nav-icon fas fa-gift"></i>
                  <p>
                    Manage Offers
                    <i className={`right fas fa-angle-left ${openMenu === "offers" ? "open" : ""}`} />
                  </p>
                </Link>

                <ul
                  className="nav nav-treeview"
                  style={{ display: openMenu === "offers" ? "block" : "none" }}
                >
                  <li>
                    <Link
                      to="flight-banner"
                      className={
                        location.pathname === "/flight-banner" ||
                          location.pathname.startsWith("/edit-flight-banner/") ||
                          location.pathname === "/edit-flight-banner" ||
                          location.pathname.startsWith("/add-flight-banner")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-images"></i>
                      <p>&nbsp;Promotional Banners</p>
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="offers-management-list"
                      className={
                        location.pathname === "/offers-management-list" ||
                          location.pathname.startsWith("/edit-offers-management/") ||
                          location.pathname === "/edit-offers-management" ||
                          location.pathname.startsWith("/add-offers-management")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-tags"></i>
                      <p>&nbsp;Offers Management</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a
                  href="#"
                  onClick={() => handleMenuToggle("hotelCity")}
                  className="nav-link"
                >
                  <i className="nav-icon fas  fa-map"></i>
                  <p>
                    {" "}
                    Hotel{" "}
                    <i
                      className={`right fas fa-angle-left ${openMenu === "hotelCity" ? "open" : ""
                        }`}
                    />
                  </p>
                </a>
                <ul
                  className="nav nav-treeview"
                  style={{
                    display: openMenu === "hotelCity" ? "block" : "none",
                  }}
                >
                  <li>
                    <Link
                      to="manage-hotel-city-list"
                      className={
                        location.pathname === "/manage-hotel-city-list"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-plane"></i>
                      <p>Add City Detail</p>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <a
                  href="#"
                  onClick={toggleSubMenuDestination}
                  className="nav-link"
                >
                  <i className="nav-icon fas  fa-map"></i>
                  <p>
                    {" "}
                    Destination{" "}
                    <i
                      className={`right fas fa-angle-left ${isOpenDestination ? "open" : ""
                        }`}
                    />
                  </p>
                </a>

                <ul
                  className="nav nav-treeview"
                  style={{ display: isOpenDestination ? "block" : "none" }}
                >
                  <li>
                    <Link
                      to="manage-airport-destinations-list"
                      className={
                        location.pathname ===
                          "/manage-airport-destinations-list" ||
                          location.pathname.startsWith("/edit-package/") ||
                          location.pathname === "/add-tour-and-packages" ||
                          location.pathname.startsWith("/add-tour-and-packages/")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-plane"></i>
                      <p>Manage Airport</p>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="popular-airPort-destination"
                      className={
                        location.pathname === "/popular-airPort-destination" ||
                          location.pathname.startsWith(
                            "/edit-manage-airport-destination/"
                          ) ||
                          location.pathname ===
                          "/add-popular-airPort-destination" ||
                          location.pathname.startsWith(
                            "/add-manage-airport-destinations/"
                          )
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-plane-departure"></i>
                      <p>Popular Airport</p>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link"
                  style={{ cursor: "pointer" }}
                  onClick={logoutUser}
                >
                  <i className="nav-icon fas fa-lock" />
                  <p>Logout</p>
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* {userType?.user_type !== "SEO" && (
             
              )} */}
      </aside>
    </>
  );
};

export default SeoMenu;
